// React
import React from 'react';
import { Row } from 'reactstrap';

// Injection
import {
  PageWrapper,
  ModalDelete,
  ListCategories,
} from '../../containers/componentsInjection';

export const CategoriesFinancePage = ({
  history,
  isDelete,
  setIsDelete,
  toggle_delete,
  handleDelete,
  categoryFinances,
}) => {
  return (
    <PageWrapper title={'Categorias'}>
      <Row>
        <ListCategories
          title={'Despesas'}
          data={categoryFinances.D}
          navigation={() => history.push('/financeiro/contas/novo/despesas')}
          handleDelete={(id) => toggle_delete(id)}
          handleEdit={(id) => history.push(`/financeiro/edit/${id}/despesas`)}
        />
        <ListCategories
          title={'Receitas'}
          data={categoryFinances.R}
          navigation={() => history.push('/financeiro/contas/novo/receitas')}
          handleDelete={(id) => toggle_delete(id)}
          handleEdit={(id) => history.push(`/financeiro/edit/${id}/receitas`)}
        />

        <ModalDelete
          isOpen={isDelete}
          handleDelete={handleDelete}
          goBack={() => setIsDelete(!isDelete)}
        />
      </Row>
    </PageWrapper>
  );
};
